<div class="row">
	<fieldset [disabled]="!editable">
		<div class="col-sm">
			<label for="name" class="pt-3">Nazwa lokalizacji<small class="ms-2 text-danger">* wymagane</small></label>
			<input
				type="text"
				id="name"
				[className]="isEmptyName ? 'form-control is-invalid mt-1' : 'form-control mt-1'"
				name="name"
				(change)="checkForm()"
				[(ngModel)]="data.name"
				required
			/>
			<div *ngIf="isEmptyName" class="invalid-feedback">To pole nie może być puste!</div>
		</div>
		<div class="col-sm">
			<label for="code" class="pt-3">Kod</label>
			<input
				type="text"
				max="3"
				[className]="isEmptyCode && isCountry ? 'form-control is-invalid mt-1' : 'form-control mt-1'"
				id="code"
				placeholder="(max 3 znaki)"
				maxlength="3"
				name="code"
				(change)="checkForm()"
				[(ngModel)]="data.code"
				required
			/>
			@if (isEmptyCode && isCountry) {
				<div class="invalid-feedback">To pole nie może być puste, gdy rodzaj lokalizacji to Państwo!</div>
			}
		</div>
		<div class="d-flex justify-content-between align-items-end">
			<div class="col-sm p-3">
				<ng-select
					id="locationKind"
					name="locationKind"
					[(ngModel)]="data.locationKind"
					placeholder="Rodzaj lokalizacji"
					[disabled]="!editable"
					(change)="countryCheck()"
					required
				>
					<ng-option [value]="item.value" *ngFor="let item of locationsKinds">
						{{ item.name }}
					</ng-option>
				</ng-select>
			</div>
			<div class="col-sm p-3">
				<ng-select
					id="parentLocation"
					name="parentLocation"
					[(ngModel)]="data.parentLocation"
					placeholder="Lokalizacja nadrzędna"
					[disabled]="!editable"
					required
				>
					<ng-option [value]="item.id" *ngFor="let item of locations">
						{{ item.id }} | {{ item.name }}
					</ng-option>
				</ng-select>
			</div>
		</div>
	</fieldset>
</div>
